export const COLORS = {
  primary: '#007AFF',

  // Surface and foreground shared by the floating buttons, cards and panels.
  surface: '#FFFfff',
  ink: '#03045E',

  // Guides & News list rows: even rows are light, odd rows are dark.
  articleEvenBackground: '#FFFfff',
  articleOddBackground: '#023E8A',
};
